/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import titleBox from "components/title-box/title-box";
import initHeader from "components/header/header";
import modal from "imComponents/modal/modal";
import heroSlider from "imComponents/hero-slider/hero-slider";
import heroImage from "imComponents/hero-image/hero-image";
import button from "components/buttons/buttons";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import cmsContent from "components/cms-content/cms-content";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import cropAnimation from "animations/crop-animation/crop-animation";
import videoAutoplayOnEnter from "animations/video-autoplay-onenter/video-autoplay-onenter";
import blockVideo from "components/block-video/block-video";
import animateIn from "animations/animate-in/animate-in";
import cardTextOnBg from "components/cards/card-text-on-bg";
import twoColSlider from "components/two-col-slider/two-col-slider";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import accordion from "imComponents/accordion/accordion";
import cardNews from "components/cards/card-news";
import sliderNews from "components/slider-news/slider-news";
import customAccordion from "components/custom-accordion/custom-accordion";
import customQuote from "components/custom-quote/custom-quote";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";
import line from "components/line/line";
import blockInfographic from "components/block-infographic/block-infographic";
import boxModules from "components/box-modules/box-modules";
import textIframe from "components/text-iframe/text-iframe";
import partners from "components/partners/partners";
import blockFeatures from "components/block-features/block-features";
import banner from "components/banner/banner";
import sliderBandi from "components/slider-bandi/slider-bandi";
import cardBandi from "components/cards/card-bandi";
import colTitleText from "components/col-title-text/col-title-text";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import textImgVar from "imComponents/text-img-var/text-img-var";
import sliderText from "components/slider-text/slider-text";
import heroBanner from "components/hero-banner/hero-banner";
import boxImage from "components/box-image/box-image";

//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector("body.wp-admin")) {
        initHeader();
        heroSlider();
    }
    animateIn();
    modal();
    accordion();
    sliderNews();
    twoColSlider();
    carouselGallery();
    blockInfographic();
    sliderBandi();
    blockVideo();
    cropAnimation();
    videoAutoplayOnEnter();
    sliderText();
}
if (document.querySelector("body.wp-admin")) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction("render_block_preview", initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
